import { render, staticRenderFns } from "./RemindingFolders.vue?vue&type=template&id=632a66b9&"
import script from "./RemindingFolders.vue?vue&type=script&lang=js&"
export * from "./RemindingFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports